import { createSelector } from '@reduxjs/toolkit';

import { createCustomSelector } from '@/utils/functions';
import { sectionTypes } from '@/utils/sectionEnums';

export const selectPodcastRequesting = (state) => state.podcast.requesting;
export const selectPodcastError = (state) => state.podcast.error;

export const selectPodcastId = (state) => state.podcast.id;
export const selectPodcastUID = (state) => state.podcast.uid;
export const selectPodcastSID = (state) => state.podcast.sid;
export const selectPodcastIsAdded = (state) => state.podcast.isAdded;
export const selectPodcastIsActive = (state) => state.podcast.isActive;

export const selectPodcastItems = (state) => state.podcast.items;
export const selectPodcastAlbums = (state) => state.podcast.albums;
export const selectPodcastHeading = (state) => state.podcast.heading;

export const selectPodcastBlockContent = createSelector(
  (state) => state.podcast,
  (podcast) => ({
    heading: podcast.heading,
    items: podcast.items,
    albums: podcast.albums,
  }),
);

export const selectPodcastBlockDesign = createSelector(
  (state) => state.podcast,
  (podcast) => ({
    containerDesign: podcast.containerDesign,
    itemDesign: podcast.itemDesign,
    buttonDesign: podcast.buttonDesign,
    view: podcast.designView,
    layout: podcast.designLayout,
  }),
);

export const selectPodcastContainerDesign = (state) => state.podcast.containerDesign;
export const selectPodcastItemDesign = (state) => state.podcast.itemDesign;
export const selectPodcastButtonDesign = (state) => state.podcast.buttonDesign;

export const selectPodcastDesignView = (state) => state.podcast.designView;
export const selectPodcastDesignLayout = (state) => state.podcast.designLayout;

export const selectHeadingObj = createCustomSelector(sectionTypes.podcast.type);
